import React, { useEffect, useState } from 'react';
import { Grid, Checkbox } from "@mui/material";
import MuiSelect from "components/MuiSelect/MuiSelect";
import { getAllRoles } from "apis/user";

interface CheckGroupProps {
  product: string,
  updateList: Function,
  roleList: any,
  userData: any,
  userToEdit?: any
}

var flag:boolean = false;
const CheckGroup: React.FC<CheckGroupProps> = ({ product, updateList, userData, roleList, userToEdit }) => {
  const [checked, setChecked] = useState(false);
  const [currentVal, setCurrentVal] = useState(roleList[product].roles[0]);
  const [masterRoles, setMasterRoles] = useState([]);

  useEffect(() => {
    flag = false;
    const getMasterRoles = async () => {
      try {
        let data = await getAllRoles();
        setMasterRoles(data);
      } catch (e) {
        console.log(e);
      }
    }
    getMasterRoles();
  }, [])


  useEffect(() => {
    flag = false;
    if (userData !== null && userData.userRoleList.length > 0) {
      let data = userData.userRoleList.filter((u: any) => u.application === product);
      if (data.length > 0) {
        //console.log(userData);
        setChecked(true);
      }
    }
  }, [userData]);

  useEffect(() => {
    flag = false;
    if(userToEdit !== undefined && masterRoles.length > 0) {
      updateList(userData.userRoleList);
      let data = userData.userRoleList.filter((d: any) => d.application === product);
      if(data.length > 0) {
        setCurrentVal(data[0].roleName);
      }
    }
  }, [userToEdit, masterRoles]);

  const getRoleId = () => {
    let found: any = masterRoles.filter((f: any)  => (f.applicationName === product && f.roleName === currentVal));
    if(found.length > 0) {
      return found[0].roleId
    }
    // return 40;
  }

  useEffect(() => {
    //flag = false;
    if (checked && masterRoles.length > 0) {
      let data = userData.userRoleList.filter((d: any) => d.application === product);
      let roleId = getRoleId();
      // handles new role add
      if (data.length === 0) {
        //console.log(roleId);
        let obj = {
          application: product,
          roleName: currentVal,
          userId: userData.userId,
          roleId: roleId
        }
        updateList([...userData.userRoleList, obj]);
      } else {
        // if there is already one of the same product replace
        let newData = [...userData.userRoleList];
        //console.log(roleId);
        for(let i = 0; i < newData.length; i++) {
          if(newData[i].application === product) {
            newData[i] = {
              application: product,
              roleName: currentVal,
              userId: userData.userId,
              roleId: roleId
            }
          }
        }
        updateList(newData);
      }

    }
    // handles removal
    if(flag){
      if (!checked) {
        let data = userData.userRoleList.filter((d: any) => d.application !== product);
        //console.log(checked,data);
        //console.log(userData);
        updateList(data);
      }
    }


  }, [checked, currentVal]);

  let onCheckApplication = (e:any)=>{
    flag = true;
    setChecked(e.target.checked)
  }

  let onChangeRole = (val:any)=>{
    flag = true;
    setCurrentVal(val)
  }

  return (
    <div key={product} style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
      <Checkbox size="small" checked={checked} onChange={(e) => onCheckApplication(e) } />
      <Grid item xs={5}>{product}</Grid>
      <Grid item xs={6}>
        <Grid item xs={12} sx={{ marginBottom: 0 }}>
          <MuiSelect
            value={currentVal}
            options={roleList[product].roles}
            onChangeHandler={(val: any) => onChangeRole(val) }
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default CheckGroup;
